import Cookies from 'js-cookie'
// cookie保存的天数
import config from '@/config'
const { cookieExpires } = config

export const TOKEN_KEY = 'token'
export const CART_KEY = 'cart'
export const APP_TYPE_KEY = 'app_type'

export const setToken = (token) => {
  Cookies.set(TOKEN_KEY, token, { expires: cookieExpires || 1 })
}

export const delToken = () => {
  Cookies.remove(TOKEN_KEY)
}

export const setAppType = (type) => {
  Cookies.set(APP_TYPE_KEY, type, { expires: cookieExpires || 1 })
}

export const delAppType = () => {
  Cookies.remove(APP_TYPE_KEY)
}

export const setCart = (cart) => {
  const data = JSON.stringify(cart)
  Cookies.set(CART_KEY, data, { expires: cookieExpires || 1 })
}

export const getToken = () => {
  const token = Cookies.get(TOKEN_KEY)
  if (token) return token
  else return false
}

export const getAppType = () => {
  const type = Cookies.get(APP_TYPE_KEY)
  if (type) return type
  else return false
}

export const getCart = () => {
  const cart = Cookies.get(CART_KEY)
  if (cart) return JSON.parse(cart)
  else return []
}

export const localSave = (key, value) => {
  localStorage.setItem(key, value)
}

export const localRead = (key) => {
  return localStorage.getItem(key) || ''
}

// scrollTop animation
export const scrollTop = (el, from = 0, to, duration = 500, endCallback) => {
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = (
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function (callback) {
        return window.setTimeout(callback, 1000 / 60)
      }
    )
  }
  const difference = Math.abs(from - to)
  const step = Math.ceil(difference / duration * 50)

  const scroll = (start, end, step) => {
    if (start === end) {
      endCallback && endCallback()
      return
    }

    let d = (start + step > end) ? end : start + step
    if (start > end) {
      d = (start - step < end) ? end : start - step
    }

    if (el === window) {
      window.scrollTo(d, d)
    } else {
      el.scrollTop = d
    }
    window.requestAnimationFrame(() => scroll(d, end, step))
  }
  scroll(from, to, step)
}



// WEBPACK FOOTER //
// ./src/libs/util.js